export default __webpack_public_path__ + "static/383-5ddd2653c365828df29fb25e0e060353.gif";